import React from "react";
import "./Header.css";
const Header = () => {
  return (
    <div>
      <header>
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Books-aj.svg_aj_ashton_01f.svg/640px-Books-aj.svg_aj_ashton_01f.svg.png" alt="" />
        <h1>IELTS Book Shop</h1>
      </header>
    </div>
  );
};

export default Header;
